<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.message}}</p>
  <form [formGroup]="dosageUnitForm">
    <p>
        <mat-form-field appearance="outline">
            <mat-label>Unit</mat-label>
            <input required formControlName="unit" type="text" matInput placeholder="Name">
            <mat-error *ngIf="dosageUnitForm.get('unit')?.invalid">
                Unit is invalid
            </mat-error>
        </mat-form-field>
    </p>
    <p>
        <mat-form-field appearance="outline">
            <mat-label>Symbol</mat-label>
            <input required formControlName="symbol" type="text" matInput placeholder="Barcode prefix">
            <mat-error *ngIf="dosageUnitForm.get('symbol')?.invalid">
                Symbol is invalid
            </mat-error>
        </mat-form-field>
    </p>
    <p>
        <mat-form-field appearance="outline">
            <mat-label>Code</mat-label>
            <input required formControlName="code" type="text" matInput placeholder="Code">
            <mat-error *ngIf="dosageUnitForm.get('code')?.invalid">
                Code is invalid
            </mat-error>
        </mat-form-field>
    </p>
</form>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
  <button [disabled]="!dosageUnitForm.valid" mat-raised-button  color="primary" (click)="createDosageUnit()">Create</button>
</div>
